/* global: XmlHttpRequest */

var ready = require('./ready.js');

var replaceHtml = function(form, newHtml) {
    var newElement = document.createElement('div');
    newElement.innerHTML = newHtml;
    newElement = newElement.children[0];
    form.parentNode.insertBefore(newElement, form);
    form.parentNode.removeChild(form);
    bindListeners([newElement]);
};

var showError = function(form) {
    replaceHtml(form, '<div class="error message">Fehler bei der Anfrage. Bitte versuchen Sie es später noch einmal.</div>');
};

var bindListeners = function(forms) {
    Array.prototype.forEach.call(forms, function(form) {
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            var request = new XMLHttpRequest();
            request.open(form.getAttribute('method'), form.getAttribute('action'), true);

            request.onload = function() {
                try {
                    if (this.status >= 200 && this.status < 400) {
                        replaceHtml(form, this.response);

                        if (this.status === 201) {
                            // time to redirect
                            setTimeout(function() {
                                window.location = request.getResponseHeader('X-RedirectTo');
                            }, 1500);
                        }
                    } else {
                        showError(form);
                    }
                } catch (e) {
                    showError(form);
                }
            };

            request.onerror = showError.bind(null, form);

            var data = new FormData(form);
            request.send(data);
        });
    });
};

ready(function() {
    var forms = document.querySelectorAll('form.via-ajax');
    bindListeners(forms);
});
